import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';
import { ColDef, GridOptions } from 'ag-grid-community';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class MyOrdersComponent implements OnInit {

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

      // Debounce search.
      this.searchUserUploaderUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetUserUploadersFiltered(value);
        });

          // Debounce search.
     this.searchUserManagerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetUserManagersFiltered(value);
      });

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, null, true);
      });
  
     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.GetInvoicesFiltered(this.Filter.Pager.PageIndex = 1);
        }
      });

     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.GetInvoicesFiltered(this.Filter.Pager.PageIndex = 1);
        }
      });

     // Debounce search.
     this.ordersSearchTermUpdate.pipe(
      debounceTime(350),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length > 2){
            this.GetB2BClientOrders(1, value);
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  searchPartnerUpdate = new Subject<string>();
  searchUserManagerUpdate = new Subject<string>();
  searchUserUploaderUpdate = new Subject<string>();
  ordersSearchTermUpdate = new Subject<string>();

  ngOnInit(): void {
    this.InitializeFilter();
    this.parent.InitializeCart();
    this.GetInvoiceMasterData();
  }

  Filter: {[k: string]: any} = {};
  MasterData: {[k: string]: any} = {};
  CurrentShippingAddress:any;
  activeFilters:{[k: string]: any} = [];
  Orders:{[k: string]: any} = [];
  Totals:{[k: string]: any} = [];
  searchTerm:string;
  Partners:any[];
  resultsLength:number = 0;
  partner:any;
  CurrentOrder:any;
  Invoices:any[];
  ReadyItems:any[];

  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DocumentStatuses:any[];
  Periods:any[];
  Languages:any[];
  PaymentTerms:any[];
  DiscountTypes:any[];
  Agents:any[];
  Countries:any[];
  CashCollectTypes:any[];
  CashCollections:any[];
  ShowSuggestionCashCollectionsContainer:boolean;
  CashTotals:any[];
  SortingOrders:any[];
  CountryFilterOptions:any[];
  PartnerTypes:any[];
  TranzactionTypes:any[];
  InvoiceModels:any[];
  currentCashCollettion: {[k: string]: any} = {};
  currency:any;
  BankAccounts:any[];
  InvoicePrecision:any;

  ShippingResponsabilities:any[];
  ShippingResponsability:any;
  ShippingServiceTypes:any[];
  ShippingServiceType:any;
  PartnerShippingAddresses:any[];
  SelectedShippingAddress:any;

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  loadingOrders:boolean;
  showFilter:boolean;
  ShowExportBulkQuestion:boolean;
  AllSelected:boolean;
  ShowOrderCancelation:boolean;
  ShowOrderCopy:boolean;
  ShowEditContainer:boolean;

  SearchUserManager:string;
  UserManagers:any[];
  UserManagersLength:number = 0;
  UserManager:any;

  SearchUserUploader:string;
  UserUploaders:any[];
  UserUploadersLength:number = 0;
  UserUploader:any;

  ShowOrderBillingInformation:boolean = true;
  ShowOrderShippingInformation:boolean = true;
  ShowOrderGeneralInformation:boolean = true;
  ShowOrderProductsInformation:boolean = false;
  ShowOrderDetailsPage:boolean = false;
  ShowOrders:boolean = true;
  ShowTransitItems:boolean = false;

  ShowOrdersClick(){
    this.ShowOrders = true;
    this.ShowTransitItems = false;
  }

  ShowReadyItems(){
    this.ShowOrders = false;
    this.ShowTransitItems = false;
    this.GetB2BClientOCReadyItemsUX();
    this.GetSupplierClientOpenBoxes();
  }

  ShowTransitItemsClick(){
    this.ShowOrders = false;
    this.ShowTransitItems = true;
    this.GetB2BClientOCTransitItemsUX();
  }

  TransitItems:any[];
  TransitItemsTotal:any;
  TransitItemsTotalCurrency:string;

  getFilteredTransitItems() {
    if (!this.TransitItems) return [];
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for date-only comparison
    return this.TransitItems.filter(item => {
      if (!item.EstiMatedArrivalDate) return true; // Show items without date
      const arrivalDate = new Date(item.EstiMatedArrivalDate);
      arrivalDate.setHours(0, 0, 0, 0); // Reset time to midnight
      return arrivalDate > today; // Only show future dates (exclude today and past)
    });
  }

  GetB2BClientOCTransitItemsUX(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
    };

    this.parent.loading = true;

    this.B2BService.GetOrderConfirmationsTransitItems(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.TransitItems = response["TransitItems"];
        this.TransitItemsTotal = response["TransitItemsTotal"];
        this.TransitItemsTotalCurrency = response["TransitItemsTotalCurrency"];
      }

      this.parent.loading = false;
     });
  }

  ReadyItemsTotal:any;
  ReadyItemsTotalCurrency:string;

  GetB2BClientOCReadyItemsUX(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:this.parent.B2BPartner,
    };
  
    this.parent.loading = true;
  
    this.B2BService.GetB2BClientOCReadyItemsUX(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ReadyItems = response["Items"];
        this.ReadyItemsTotal = response["ReadyItemsTotal"];
        this.ReadyItemsTotalCurrency = response["ReadyItemsTotalCurrency"];
        this.ShippingResponsabilities = response["ShippingResponsabilities"];
        // Filter out ShippingServiceType with ID == 2
        this.ShippingServiceTypes = response["ShippingServiceTypes"]?.filter(x => x.ID != 2) || [];

        this.GetPartnerShippingAddresses(this.parent.B2BPartner?.ID);
        this.GetPartnerAgents(this.parent.B2BPartner?.ID);
      }
  
      this.parent.loading = false;
     });
  }

  GetInvoicesFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    if(this.Filter.DisplayAllPagesTotals == true){
      this.Filter.ExchangeToTargetCurrency = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }
    
    this.parent.loading = true;
    this.showFilter = false;

    this.B2BService.GetB2BInvoices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Invoices = response["Invoices"];
        this.Totals = response["Totals"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
      
      this.AllSelected = false;
      this.parent.loading = false;
    });

    this.GetInvoicesFilteredCOUNT();
  }

  GetInvoicesFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.B2BService.GetInvoicesFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];
        this.Languages = response["Languages"];
        this.PaymentTerms = response["PaymentTerms"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DiscountTypes = response["DiscountTypes"];
        this.Agents = response["Agents"];
        this.DocTypes = response["DocTypes"];
        this.Periods = response["Periods"];
        this.DocumentStatuses = response["DocumentStatuses"];
        this.Countries = response["Countries"];
        this.CashCollectTypes = response["CashCollectTypes"];
        this.currentCashCollettion.Type = this.CashCollectTypes[1];
        this.BankAccounts = response["BankAccounts"];
        this.SortingOrders = response["SortingOrders"];
        this.CountryFilterOptions = response["CountryFilterOptions"];
        this.PartnerTypes = response["PartnerTypes"];
        this.TranzactionTypes = response["TranzactionTypes"];
        this.InvoiceModels = response["InvoiceModels"];

        this.currency = this.Currencies[0];
        this.InvoicePrecision = this.DecimalPrecisions[0];
        this.Filter.SortingOrder = this.SortingOrders[0];
        this.Filter.Partner = this.parent.B2BPartner;

        this.GetB2BClientOrders();
      }
      
      this.parent.loading = false;
    });
  }

  

InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Administration = {};
    this.Filter.AccountingSeries = {};
    this.Filter.Product = "";
    this.Filter.Partner = {};
    this.Filter.DocumentNumber = "";
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.SortingOrder = {};
    this.Filter.SortingOrder = null;

    this.Filter.InvoiceDocType = {};
    this.Filter.InvoiceDocType = null;

    this.Filter.CountryFilterOption = {};
    this.Filter.CountryFilterOption = null;

    this.Filter.PartnerType = {};
    this.Filter.PartnerType = null;

    this.Filter.TranzactionType = {};
    this.Filter.TranzactionType = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;
    this.Filter.ExchangeToTargetCurrency = false;
}

ClearPeriod(){
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  this.Filter.Period = null;
}

DisablePeriod(){
  this.Filter.Period = null;
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
}

GetOfferMasterData(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.parent.loading = true;

  this.B2BService.GetOfferMasterData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MasterData = response;
      this.GetOrdersFiltered(1);
    }

    this.parent.loading = false;
   });
}

GetOrdersFiltered(page = 1){

  this.Filter.Pager.PageIndex = page;

  if(this.Filter.DisplayAllPagesTotals == true){
    this.Filter.ExchangeToTargetCurrency = false;
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }
  
  this.loadingOrders = true;
  this.showFilter = false;

  this.B2BService.GetOffersFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders = response["OfferRequests"];
      this.Totals = response["Totals"];
      // Pager with TotalCount is now returned from the main query
      this.Filter.Pager = response["Pager"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }

    this.loadingOrders = false;
  });

  // No need for separate COUNT call - it's included in the main response now
}

GetOrdersFilteredCOUNT(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }

  this.B2BService.GetOffersFilteredCOUNT(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Filter.Pager = response["Pager"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
 
  });
}

AddActiveFilter(filterName:string, filterType:string){
  var filter = {
    ID:this.parent.newGuid(),
    Name:filterName,
    Type:filterType
  };
  
  if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
    this.showFilter = false;
  }

  this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
  this.activeFilters.push(filter);

  if(filterType == "Period"){
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;

    this.FromDate = new FormControl(moment(this.Filter.FromDate));
    this.ToDate = new FormControl(moment(this.Filter.ToDate));
  }

  this.GetB2BClientOrders();
}

RemoveActiveFilter(ID:string, filterType:string){
  this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

  if(filterType == "Administration"){
    this.Filter.Administration = null;
  }
  else if(filterType == "Series"){
    this.Filter.AccountingSeries = null;
  }
  else if(filterType == "DocStatus"){
    this.Filter.DocumentStatus = null;
  }
  else if(filterType == "DocumentNumber"){
    this.Filter.DocumentNumber = null;
  }
  else if(filterType == "Product"){
    this.Filter.Product = null;
  }
  else if(filterType == "Partner"){
    this.Filter.Partner = null;
  }
  else if(filterType == "Period"){
    this.Filter.Period = null;
  }
  else if(filterType == "Country"){
    this.Filter.Country = null;
  }
  else if(filterType == "Currency"){
    this.Filter.Currency = null;
  }
  else if(filterType == "InvoiceDocType"){
    this.Filter.InvoiceDocType = null;
  }

  this.GetB2BClientOrders();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.Orders.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SelectAll(){
  this.Orders.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:10,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.Partners = [];
    this.resultsLength = 0;
  }
}

GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:50,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if(this.searchTerm.length >= 3){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];

       if(this.Partners.length == 1){
        this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
        this.GetInvoicesFiltered(1);
       }
      }
   
      this.parent.loading = false;
    });
  }
}

InitializeUserManagersOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserManagers == null || this.UserManagers.length == 0)){
    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserManagers = response["Users"];
        this.UserManagersLength = this.UserManagers.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserManagers = [];
    this.UserManagersLength = 0;
  }
}

GetUserManagersFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.service.GetUsersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserManagers = response["Users"];
      this.UserManagersLength = this.UserManagers.length;
    }
 
    this.parent.loading = false;
  });

}

InitializeUserUploadersOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserUploaders == null || this.UserUploaders.length == 0)){
    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserUploaders = response["Users"];
        this.UserUploadersLength = this.UserUploaders.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserUploaders = [];
    this.UserUploadersLength = 0;
  }
}

GetUserUploadersFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.service.GetUsersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserUploaders = response["Users"];
      this.UserUploadersLength = this.UserUploaders.length;
    }
 
    this.parent.loading = false;
  });

}

OpenOrderCancelation(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCancelation = true;
}

CancelOrder(o:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:o.DBID,
    PartnerID:this.parent.B2BPartner?.ID,
  };

  this.parent.loading = true;

  this.B2BService.CancelOfferByPartner(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders.forEach(order => {
        if(order.DBID == o.DBID){
          order.ProcessingStatus = response["ProcessingStatus"];
          order.OfferRequestStatus = response["OfferRequestStatus"];
        }
      });
    }
 
    this.parent.loading = false;
  });
}

OpenCopyOrder(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCopy = true;
}

CopyOrder(o:any){
  this.GetOffer(o.ID);
}

GetOffer(RequestOfferID:string){
  var request = {
  User:this.parent.User,
  Language:this.parent.getLanguage(),
  RequestOfferID:RequestOfferID,
  PartnerID:this.parent.B2BPartner?.ID,
  GetCartItems:true,
  WithLogs:true,
};

this.parent.loading = true;

this.B2BService.GetOfferByPartner(request).subscribe(response => {

  if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.CurrentOrder = response["OfferRequest"];
    this.ShowEditContainer = true;
  }

  this.parent.loading = false;
});

}

PrintOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
    PartnerID:this.parent.B2BPartner?.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOfferByPartner(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.parent.loading = false;
  });
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ExportOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
    PartnerID:this.parent.B2BPartner?.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOfferByPartner(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.parent.loading = false;
  });
}


printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.CurrentOrder.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

GetInvoiceByAccountingDisplayValue(i:any, print:boolean = true){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    AccountingDisplayValue:i.AccountingNumber.DisplayValue,
    PartnerID:this.parent.B2BPartner?.ID,
    UseInvoiceLanguage:true,
    ExportPDF:true,
  };

  this.parent.loading = true;

  this.service.GetInvoiceByAccountingDisplayValueByPartner(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Document = response["Document"];

      if(print == true){
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }
      else{
        this.download(Document.Name, Document.PDFStream);
      }
    }

    this.parent.loading = false;
  });
}

PrintInvoice(i:any){

  var user = JSON.parse(JSON.stringify(this.parent.User));

  user.Rights.AssignedCompanies.forEach(element => {
    element.IsSelected = false;
  });

  if(user.Rights.AssignedCompanies.some(x => x.ID == this.Filter.Company.ID)){
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }
  else{
    user.Rights.AssignedCompanies.push(JSON.parse(JSON.stringify(this.Filter.Company)));
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }

  var request = {
    User:user,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.parent.loading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.parent.loading = false;
  });
}

ExportInvoice(i:any){

  var user = JSON.parse(JSON.stringify(this.parent.User));

  user.Rights.AssignedCompanies.forEach(element => {
    element.IsSelected = false;
  });

  if(user.Rights.AssignedCompanies.some(x => x.ID == this.Filter.Company.ID)){
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }
  else{
    user.Rights.AssignedCompanies.push(JSON.parse(JSON.stringify(this.Filter.Company)));
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }

  var request = {
    User:user,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.parent.loading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.parent.loading = false;
  });
}

Companies:any[];

GetB2BPartnerRelatedCompanies(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    B2BPartner:this.parent.B2BPartner,
  };

  this.parent.loading = true;

  this.B2BService.GetB2BPartnerRelatedCompanies(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Companies = JSON.parse(JSON.stringify(response["Companies"]));
      this.Filter.Company = this.Companies[0];
      this.GetInvoicesFiltered();
    }

    this.parent.loading = false;
  });
}

GetB2BClientOrders(page = 1, value:string = ''){

  if(this.Filter?.Pager != null){
    this.Filter.Pager.PageIndex = page;
  }

  this.Filter.Product = value;
  this.Filter.Partner = this.parent.B2BPartner;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingOrders = true;

  this.B2BService.GetB2BClientOrders(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders = JSON.parse(JSON.stringify(response["Orders"]));
      this.Filter.Pager = JSON.parse(JSON.stringify(response["Pager"]));
    }

    this.loadingOrders = false;
  });
}

Order:any;
ShowOrderDetailsMenu:boolean = false;
ShowOrderDocumentsMenu:boolean = false;

// AG Grid Options for Order Details Tables
openItemsGridOptions: GridOptions;
readyItemsGridOptions: GridOptions;
deliveredItemsGridOptions: GridOptions;

openItemsColumnDefs: ColDef[] = [
  { headerName: 'Position', field: 'position', flex: 0.5, minWidth: 80, editable: false, sortable: false, filter: false },
  { headerName: 'Brand', field: 'Product.Brand.Name', flex: 1, minWidth: 120, editable: false, sortable: false, filter: false },
  {
    headerName: 'Product',
    field: 'Product.Name',
    flex: 2,
    minWidth: 200,
    editable: false,
    sortable: false,
    filter: false,
    cellRenderer: (params: any) => {
      let html = `<div style="line-height: 1.3;">`;
      html += `<div style="font-weight: 500;">${params.data.Product?.Name || ''}</div>`;
      if (params.data.Product?.PartNumber) {
        html += `<div style="font-size: 10px; color: #666;">Part Number: <span style="font-weight: 400; color: #333;">${params.data.Product.PartNumber}</span></div>`;
      }
      if (params.data.Product?.Stats?.HSCode) {
        html += `<div style="font-size: 10px; color: #666;">HS Code: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.HSCode}</span></div>`;
      }
      if (params.data.Product?.Stats?.COO?.Name) {
        html += `<div style="font-size: 10px; color: #666;">COO: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.COO.Name} (${params.data.Product.Stats.COO.ShortName})</span></div>`;
      }
      if (params.data.Product?.Stats?.Weight != null) {
        html += `<div style="font-size: 10px; color: #666;">Weight: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.Weight} ${params.data.Product.Stats.WeightMeasurementType?.Name || ''}</span></div>`;
      }
      html += `</div>`;
      return html;
    }
  },
  {
    headerName: 'ETA',
    field: 'SelectedOffer.LeadTime.ETAUI',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueGetter: (params: any) => params.data?.SelectedOffer?.LeadTime?.ETAUI || params.data?.SelectedOffer?.LeadTime?.UIOutput || '',
    valueFormatter: (params: any) => params.value ? `${params.value}` : '------'
  },
  { headerName: 'Quantity', field: 'Quantity', flex: 0.7, minWidth: 80, editable: false, sortable: false, filter: false },
  {
    headerName: 'Price',
    field: 'Price.UIUnitPrice',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueFormatter: (params: any) => `${params.value} ${params.data.Price?.Currency?.Name || ''}`
  },
  {
    headerName: 'Total',
    field: 'Price.UIQtyPrice',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueFormatter: (params: any) => `${params.value} ${params.data.Price?.Currency?.Name || ''}`
  }
];

readyItemsColumnDefs: ColDef[] = [
  { headerName: 'Position', field: 'position', flex: 0.5, minWidth: 80, editable: false, sortable: false, filter: false },
  { headerName: 'Brand', field: 'Product.Brand.Name', flex: 1, minWidth: 120, editable: false, sortable: false, filter: false },
  {
    headerName: 'Product',
    field: 'Product.Name',
    flex: 2,
    minWidth: 200,
    editable: false,
    sortable: false,
    filter: false,
    cellRenderer: (params: any) => {
      let html = `<div style="line-height: 1.3;">`;
      html += `<div style="font-weight: 500;">${params.data.Product?.Name || ''}</div>`;
      if (params.data.Product?.PartNumber) {
        html += `<div style="font-size: 10px; color: #666;">Part Number: <span style="font-weight: 400; color: #333;">${params.data.Product.PartNumber}</span></div>`;
      }
      if (params.data.Product?.Stats?.HSCode) {
        html += `<div style="font-size: 10px; color: #666;">HS Code: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.HSCode}</span></div>`;
      }
      if (params.data.Product?.Stats?.COO?.Name) {
        html += `<div style="font-size: 10px; color: #666;">COO: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.COO.Name} (${params.data.Product.Stats.COO.ShortName})</span></div>`;
      }
      if (params.data.Product?.Stats?.Weight != null) {
        html += `<div style="font-size: 10px; color: #666;">Weight: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.Weight} ${params.data.Product.Stats.WeightMeasurementType?.Name || ''}</span></div>`;
      }
      html += `</div>`;
      return html;
    }
  },
  {
    headerName: 'ETA',
    field: 'SelectedOffer.LeadTime.ETAUI',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueGetter: (params: any) => params.data?.SelectedOffer?.LeadTime?.ETAUI || params.data?.SelectedOffer?.LeadTime?.UIOutput || '',
    valueFormatter: (params: any) => params.value ? `${params.value}` : '------'
  },
  { headerName: 'Quantity', field: 'Quantity', flex: 0.7, minWidth: 80, editable: false, sortable: false, filter: false },
  {
    headerName: 'Price',
    field: 'Price.UIUnitPrice',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueFormatter: (params: any) => `${params.value} ${params.data.Price?.Currency?.Name || ''}`
  },
  {
    headerName: 'Total',
    field: 'Price.UIQtyPrice',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueFormatter: (params: any) => `${params.value} ${params.data.Price?.Currency?.Name || ''}`
  }
];

deliveredItemsColumnDefs: ColDef[] = [
  { headerName: 'Position', field: 'position', flex: 0.5, minWidth: 80, editable: false, sortable: false, filter: false },
  { headerName: 'Brand', field: 'Product.Brand.Name', flex: 1, minWidth: 120, editable: false, sortable: false, filter: false },
  {
    headerName: 'Product',
    field: 'Product.Name',
    flex: 2,
    minWidth: 200,
    editable: false,
    sortable: false,
    filter: false,
    cellRenderer: (params: any) => {
      let html = `<div style="line-height: 1.3;">`;
      html += `<div style="font-weight: 500;">${params.data.Product?.Name || ''}</div>`;
      if (params.data.Product?.PartNumber) {
        html += `<div style="font-size: 10px; color: #666;">Part Number: <span style="font-weight: 400; color: #333;">${params.data.Product.PartNumber}</span></div>`;
      }
      if (params.data.Product?.Stats?.HSCode) {
        html += `<div style="font-size: 10px; color: #666;">HS Code: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.HSCode}</span></div>`;
      }
      if (params.data.Product?.Stats?.COO?.Name) {
        html += `<div style="font-size: 10px; color: #666;">COO: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.COO.Name} (${params.data.Product.Stats.COO.ShortName})</span></div>`;
      }
      if (params.data.Product?.Stats?.Weight != null) {
        html += `<div style="font-size: 10px; color: #666;">Weight: <span style="font-weight: 400; color: #333;">${params.data.Product.Stats.Weight} ${params.data.Product.Stats.WeightMeasurementType?.Name || ''}</span></div>`;
      }
      html += `</div>`;
      return html;
    }
  },
  {
    headerName: 'ETA',
    field: 'SelectedOffer.LeadTime.ETAUI',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueGetter: (params: any) => params.data?.SelectedOffer?.LeadTime?.ETAUI || params.data?.SelectedOffer?.LeadTime?.UIOutput || '',
    valueFormatter: (params: any) => params.value ? `${params.value}` : '------'
  },
  { headerName: 'Quantity', field: 'Quantity', flex: 0.7, minWidth: 80, editable: false, sortable: false, filter: false },
  {
    headerName: 'Price',
    field: 'Price.UIUnitPrice',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueFormatter: (params: any) => `${params.value} ${params.data.Price?.Currency?.Name || ''}`
  },
  {
    headerName: 'Total',
    field: 'Price.UIQtyPrice',
    flex: 1,
    minWidth: 100,
    editable: false,
    sortable: false,
    filter: false,
    valueFormatter: (params: any) => `${params.value} ${params.data.Price?.Currency?.Name || ''}`
  }
];

SelectOrderDetailsMenu(){
  this.ShowOrderDetailsMenu = true;
  this.ShowOrderDocumentsMenu = false;
}

SelectOrderDocumentsMenu(){
  this.ShowOrderDetailsMenu = false;
  this.ShowOrderDocumentsMenu = true;
}

GetClientOCDetails(o:any){

  o.IsLoading = true;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    OrderConfirmationID:o.ID,
    PartnerID:this.parent.B2BPartner?.ID,
  };

  this.B2BService.GetClientOCDetailsByPartner(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Order = JSON.parse(JSON.stringify(response["Order"]));
      this.ShowOrderDetailsPage = true;
      this.ShowOrderDetailsMenu = true;

      // Scroll to top of page - target the scrollable container
      const scrollContainer = document.querySelector('.loginBodyContainer');
      if (scrollContainer) {
        scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
      }
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Initialize AG Grid data with position numbers
      if (this.Order.Cart?.OpenItems) {
        this.Order.Cart.OpenItems.forEach((item: any, index: number) => {
          item.position = index + 1;
        });
      }
      if (this.Order.Cart?.ReadyItems) {
        this.Order.Cart.ReadyItems.forEach((item: any, index: number) => {
          item.position = index + 1;
        });
      }
      if (this.Order.Cart?.DeliveredItems) {
        this.Order.Cart.DeliveredItems.forEach((item: any, index: number) => {
          item.position = index + 1;
        });
      }

      // Initialize grid options
      this.initializeGridOptions();
    }

    o.IsLoading = false;
  });
}

initializeGridOptions() {
  const defaultGridOptions: GridOptions = {
    domLayout: 'autoHeight',
    suppressHorizontalScroll: false,
    defaultColDef: {
      resizable: false,
      sortable: false,
      filter: false,
      editable: false
    },
    rowHeight: 32,
    headerHeight: 32,
    suppressRowHoverHighlight: false,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    rowSelection: 'multiple',
    suppressRowClickSelection: true,
    enableRangeSelection: true
  };

  this.openItemsGridOptions = {
    ...defaultGridOptions,
    columnDefs: this.openItemsColumnDefs,
    rowData: this.Order?.Cart?.OpenItems || [],
    getRowClass: (params: any) => {
      if (params.data.ProgressStatus?.ID === -1) return 'ag-row-canceled';
      if (params.data.ProgressStatus?.ID === 2) return 'ag-row-ready';
      if (params.data.ProgressStatus?.ID === 3) return 'ag-row-send';
      return '';
    }
  };

  this.readyItemsGridOptions = {
    ...defaultGridOptions,
    columnDefs: this.readyItemsColumnDefs,
    rowData: this.Order?.Cart?.ReadyItems || [],
    getRowClass: (params: any) => {
      if (params.data.ProgressStatus?.ID === -1) return 'ag-row-canceled';
      if (params.data.ProgressStatus?.ID === 2) return 'ag-row-ready';
      if (params.data.ProgressStatus?.ID === 3) return 'ag-row-send';
      return '';
    }
  };

  this.deliveredItemsGridOptions = {
    ...defaultGridOptions,
    columnDefs: this.deliveredItemsColumnDefs,
    rowData: this.Order?.Cart?.DeliveredItems || [],
    getRowClass: (params: any) => {
      if (params.data.ProgressStatus?.ID === -1) return 'ag-row-canceled';
      if (params.data.ProgressStatus?.ID === 2) return 'ag-row-ready';
      if (params.data.ProgressStatus?.ID === 3) return 'ag-row-send';
      return '';
    }
  };
}

getOpenItemsTotal(): string {
  if (!this.Order?.Cart?.OpenItems || this.Order.Cart.OpenItems.length === 0) return '';
  const total = this.Order.Cart.OpenItems.reduce((sum: number, item: any) => sum + (item.Price?.UIQtyPrice || 0), 0);
  const first = this.Order.Cart.OpenItems[0];
  const currency = first?.Price?.Currency?.Name || first?.CartItemOrderInfo?.OrderCurrency?.Name || first?.SelectedOffer?.Currency?.Name || this.Order?.Cart?.Currency?.Name || '';
  return `${total.toFixed(2)} ${currency}`;
}

getReadyItemsTotal(): string {
  if (!this.Order?.Cart?.ReadyItems || this.Order.Cart.ReadyItems.length === 0) return '';
  const total = this.Order.Cart.ReadyItems.reduce((sum: number, item: any) => sum + (item.Price?.UIQtyPrice || 0), 0);
  const first = this.Order.Cart.ReadyItems[0];
  const currency = first?.Price?.Currency?.Name || first?.CartItemOrderInfo?.OrderCurrency?.Name || first?.SelectedOffer?.Currency?.Name || this.Order?.Cart?.Currency?.Name || '';
  return `${total.toFixed(2)} ${currency}`;
}

getDeliveredItemsTotal(): string {
  if (!this.Order?.Cart?.DeliveredItems || this.Order.Cart.DeliveredItems.length === 0) return '';
  const total = this.Order.Cart.DeliveredItems.reduce((sum: number, item: any) => sum + (item.Price?.UIQtyPrice || 0), 0);
  const first = this.Order.Cart.DeliveredItems[0];
  const currency = first?.Price?.Currency?.Name || first?.CartItemOrderInfo?.OrderCurrency?.Name || first?.SelectedOffer?.Currency?.Name || this.Order?.Cart?.Currency?.Name || '';
  return `${total.toFixed(2)} ${currency}`;
}

BackToOrders(){
  this.ShowOrderDetailsPage = false;
  this.ShowOrderDetailsMenu = true;
}

ShippingMasterData: {[k: string]: any} = {};
GeneralShippingServiceTypes:any[];
ShippingWays:any[];
ShippingCompanies:any[];
WeightTypes:any[];
Directions:any[];
ShowDeleteBoxQuestion:boolean;
CurrentBox:any;
ShippingDetails: {[k: string]: any} = {};

GetPartnerShippingAddresses(PartnerID:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:PartnerID
  };

  this.parent.loading = true;
  this.service.GetPartnerShippingAddresses(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.B2BPartner.ShippingAddresses = response["ShippingAddresses"];
      this.PartnerShippingAddresses = response["ShippingAddresses"];
      this.CurrentShippingAddress = this.parent.B2BPartner.ShippingAddresses[0];

      // Select first shipping address by default
      if (this.PartnerShippingAddresses && this.PartnerShippingAddresses.length > 0) {
        this.SelectedShippingAddress = this.PartnerShippingAddresses[0];
      }

      this.GetShippingMasterData();
    }

    this.parent.loading = false;
  });
}

PartnerAgents:any[];

GetPartnerAgents(PartnerID:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:PartnerID
  };

  this.parent.loading = true;
  this.service.GetPartnerAgents(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.PartnerAgents = response["PartnerAgents"];
    }
 
    this.parent.loading = false;
  });
}

GetShippingMasterData(){
  var request = {
   User:this.parent.User,
   Language:this.parent.getLanguage()
 };

this.parent.loading = true;

this.managementService.GetShippingMasterData(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
   this.ShippingMasterData = JSON.parse(JSON.stringify(response));
   // Filter out ShippingServiceType with ID == 2
   this.GeneralShippingServiceTypes = response["ShippingServiceTypes"]?.filter(x => x.ID != 2) || [];
   this.ShippingWays = response["ShippingWays"];
   this.ShippingCompanies = response["APIShippingCompanies"];
   this.WeightTypes = response["WeightTypes"];
   this.Directions = response["Directions"];

   this.ShippingDetails.ShippingDirection = this.Directions[0];
   this.ShippingDetails.WeightType = this.WeightTypes[0];
   this.ShippingDetails.ShippingWay = this.ShippingWays[0];
   this.ShippingDetails.ShippingResponsability = this.ShippingResponsabilities[1];
   this.ShippingDetails.ShippingServiceType = this.ShippingServiceTypes[0];
   this.Countries = this.parent.masterData.Countries;
   
   if(this.CurrentShippingAddress != null){
      var country = this.CurrentShippingAddress.Country;
      this.GetCountryShippingOptions(country);
   }
  }

  this.parent.loading = false;
 });
 }

 SelectShippingCompany(s:any){
  this.ShippingCompanies.forEach(element => {
    if (element.ID === s.ID) {
      element.IsSelected = true;
    } else {
      element.IsSelected = false;
    }
  });

  this.ShippingDetails.ShippingCompany = s;
 }

 SelectShippingServiceType(s:any){
  if(s != null){
    this.ShippingDetails.ShippingServiceType = JSON.parse(JSON.stringify(s));
    this.ShippingDetails.ShippingServiceType.IsSelected = true;

    this.ShippingDetails.ShippingCompany.ShippingServiceTypes.forEach(element => {
      element.IsSelected = false;
    });

    this.ShippingDetails.ShippingCompany.ShippingServiceTypes.filter(x => x.ID == this.ShippingDetails.ShippingServiceType.ID)[0].IsSelected = true;
  }
  else{
    this.ShippingDetails.ShippingCompany.ShippingServiceTypes = [];
  }
}

 GetCountryShippingOptions(Country:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Country:Country,
    PartnerID:this.parent.B2BPartner?.ID,
    DirectionID:this.ShippingDetails.ShippingDirection?.ID,
    ShippingCompany:this.ShippingCompanies[0]
  };

 this.parent.loading = true;

 this.managementService.GetCountryShippingOptions(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
     this.ShippingCompanies = response["ShippingCompanies"];

     if(this.ShippingCompanies.some(x => x.IsSelected == true)){
        this.SelectShippingCompany(this.ShippingCompanies.filter(x => x.IsSelected == true)[0]);
     }
     else if(this.ShippingCompanies != null && this.ShippingCompanies.length > 0){
      this.SelectShippingCompany(this.ShippingCompanies[0]);
     }
   }

   this.parent.loading = false;
   });
}

SendDispatchEmailClientRequest(){

  this.parent.B2BPartner.PartnerAgents = this.PartnerAgents; 

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.parent.B2BPartner,
    ShippingDetails:this.ShippingDetails,
    Items:this.ReadyItems,
    ClientMessage:this.ClientMessage,
  };

 this.parent.loading = true;
 this.ShowShipmentRequestPopup = false;

 this.B2BService.SendDispatchEmailClientRequest(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
    this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
   }
   
   this.parent.loading = false;
   });
}

ShowShipmentRequestPopup:boolean = false;
ClientMessage:string;

OrdersSearchTerm:string;

  // Supplier Client Open Boxes
  SupplierClientOpenBoxes: any[] = [];
  PartnerOpenBoxes: any = null;
  loadingBoxes: boolean = false;

  GetSupplierClientOpenBoxes() {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID
    };

    this.loadingBoxes = true;

    this.B2BService.GetSupplierClientOpenBoxes(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.SupplierClientOpenBoxes = [];
        this.PartnerOpenBoxes = null;
      }
      else if (response["Status"] == 1) {
        this.PartnerOpenBoxes = response["PartnerOpenBoxes"];
        this.SupplierClientOpenBoxes = this.PartnerOpenBoxes?.BoxesDetails || [];
      }

      this.loadingBoxes = false;
    });
  }

  GetPartnerOpenBoxesShippingCosts() {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      SelectedShippingAddress: this.SelectedShippingAddress
    };

    this.parent.loading = true;

    this.managementService.GetPartnerOpenBoxesShippingCosts(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if (response["Status"] == 1) {
        this.PartnerOpenBoxes = response["PartnerOpenBoxes"];
        this.SupplierClientOpenBoxes = this.PartnerOpenBoxes?.BoxesDetails || [];
        this.parent.openSnackBar("Shipping costs updated successfully", "OK", "alert-success-snackbar");
      }

      this.parent.loading = false;
    });
  }

  // Dropdown state variables (Ready Items section)
  showShippingResponsabilityResults: boolean = false;
  showShippingCompanyResults: boolean = false;
  showShippingServiceTypeResults: boolean = false;
  showShippingAddressResults: boolean = false;

  // Dropdown state variables (Popup)
  showShippingResponsabilityResultsPopup: boolean = false;
  showShippingCompanyResultsPopup: boolean = false;
  showShippingServiceTypeResultsPopup: boolean = false;

  // Dropdown state variables (Orders section)
  showPeriodResults: boolean = false;

  // Invoice selector dropdown
  showInvoiceDropdown: boolean = false;

  selectInvoiceForView(inv: any) {
    if (this.Order?.Invoices) {
      this.Order.Invoices.forEach((i: any) => i.IsSelectedForView = false);
    }
    inv.IsSelectedForView = true;
  }

  getSelectedInvoiceDisplay(): string {
    if (!this.Order?.Invoices || this.Order.Invoices.length === 0) return '';
    const selected = this.Order.Invoices.find((i: any) => i.IsSelectedForView);
    if (selected) return selected.AccountingNumber?.DisplayValue || '';
    // Auto-select first if none selected
    this.Order.Invoices[0].IsSelectedForView = true;
    return this.Order.Invoices[0].AccountingNumber?.DisplayValue || '';
  }

  // Dropdown selection methods (Ready Items section)
  selectShippingResponsability(responsability: any) {
    this.ShippingDetails.ShippingResponsability = responsability;
    this.showShippingResponsabilityResults = false;
  }

  selectShippingAddress(address: any) {
    this.SelectedShippingAddress = address;
    this.showShippingAddressResults = false;
  }

  selectShippingCompany(company: any) {
    this.ShippingDetails.ShippingCompany = company;
    this.showShippingCompanyResults = false;
  }

  selectShippingServiceType(serviceType: any) {
    this.ShippingDetails.ShippingServiceType = serviceType;
    this.showShippingServiceTypeResults = false;
  }

  // Dropdown selection methods (Popup)
  selectShippingResponsabilityPopup(responsability: any) {
    this.ShippingDetails.ShippingResponsability = responsability;
    this.showShippingResponsabilityResultsPopup = false;
  }

  selectShippingCompanyPopup(company: any) {
    this.ShippingDetails.ShippingCompany = company;
    this.showShippingCompanyResultsPopup = false;
  }

  selectShippingServiceTypePopup(serviceType: any) {
    this.ShippingDetails.ShippingServiceType = serviceType;
    this.showShippingServiceTypeResultsPopup = false;
  }

  // Dropdown selection methods (Orders section)
  selectPeriod(period: any) {
    this.Filter.Period = period;
    this.showPeriodResults = false;
    this.AddActiveFilter(period.Name, 'Period');
    this.GetB2BClientOrders(1, this.OrdersSearchTerm);
  }

  getCurrencySymbol(currencyID: number): string {
    if (!currencyID || !this.parent.masterData?.Currencies) {
      return '';
    }
    const currency = this.parent.masterData.Currencies.find(c => c.ID === currencyID);
    return currency?.Symbol || '';
  }

  getSelectedShippingCost(): any {
    if (!this.PartnerOpenBoxes?.ShippingCosts || this.PartnerOpenBoxes.ShippingCosts.length === 0) {
      return null;
    }

    if (!this.ShippingDetails?.ShippingCompany?.ID || !this.ShippingDetails?.ShippingServiceType?.ID) {
      return null;
    }

    // Find the cost that matches the selected shipping company and service type
    const matchingCost = this.PartnerOpenBoxes.ShippingCosts.find(cost =>
      cost.ShippingCompany?.ID === this.ShippingDetails.ShippingCompany.ID &&
      cost.ShippingServiceType?.ID === this.ShippingDetails.ShippingServiceType.ID
    );

    return matchingCost || null;
  }

  openTrackingUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  SelectShippingEstimate(cost: any): void {
    // Pre-select the carrier from the estimate
    if (cost?.ShippingCompany && this.ShippingCompanies?.length > 0) {
      var matchedCompany = this.ShippingCompanies.find(x => x.ID === cost.ShippingCompany.ID);
      if (matchedCompany) {
        this.SelectShippingCompany(matchedCompany);

        // Pre-select the service type if available
        if (cost.ShippingServiceType && matchedCompany.ShippingServiceTypes?.length > 0) {
          var matchedServiceType = matchedCompany.ShippingServiceTypes.find(x => x.ID === cost.ShippingServiceType.ID);
          if (matchedServiceType) {
            this.SelectShippingServiceType(matchedServiceType);
          }
        }
      }
    }

    // Open the shipment request popup
    this.ShowShipmentRequestPopup = true;
  }

}
